import { Autocomplete, Chip, FormHelperText, Grid, TextField, Typography } from "@mui/material";
import { useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import setToast from "../../helpers/toaster.helper";
import { CustomChipIcon } from '../../icon';
import { ScheduleEmailType } from '../../models/conversations/schedule-messages.model';
import { PhoneNumberModel } from "../../models/phone-number.model";
import { SettingsModel, mapToTimeZoneModel } from '../../models/settings-model';
import * as selector from "../../selectors/selectors";
import { ReportService } from '../../services/ReportService';
import { SettingsService } from '../../services/SettingsService';
import { UtilityService } from '../../services/UtilityService';
import { AppRoutes } from '../routes/route.path';
import ButtonComponent from "../shared/button/button.component";
import { ToasterTexts, appNote, buttonLabels } from "../shared/constants";
import { ToasterType } from "../shared/toaster/toaster.model";
import SettingsHeader from './settingsHeader.component';
import { useNavigate } from "react-router-dom";


interface Props {
    onClose: (isConfim: boolean) => void;
    Options: PhoneNumberModel[];
}

const ScheduledReport = (props: Props) => {
    const navigate = useNavigate();
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const PhoneNumbers: PhoneNumberModel[] = useSelector(selector.phoneNumbers)
    const Settings: SettingsModel = useSelector(selector.settingsObj)

    let ScheduleType = [{ Name: "Weekly", Value: ScheduleEmailType.WEEKLY },
    { Name: "Monthly", Value: ScheduleEmailType.MONTHLY }];

    const [emails, setEmails] = useState<any>('');
    const [IsLoading, setIsLoading] = useState<boolean>(false)
    const [selectedScheduleType, setSelectedScheduleType] = useState(0);
    const [selectedToPhoneNumbers, setSelectedToPhoneNumbers] = useState<string[]>([])
    const [inputvalue, setInputvalue] = useState<any>("")
    const [initialEmails, setInitialEmails] = useState<any>([]);
    const [initialSelectedScheduleType, setInitialSelectedScheduleType] = useState<number>(0);
    const [isDisabled, setIsDisabled] = useState(true);
    const [createReport, setCreateReport] = useState<Boolean>(true)

    const handleRoute = () => {
        navigate(AppRoutes.SCHEDULED_REPORT);
    };

    const handleCancel = () => {
        setSelectedScheduleType(initialSelectedScheduleType);
        setEmails(initialEmails);
        setIsDisabled(true)
    };

    const handleScheduleType = (e: any, value: any) => {
        setIsDisabled(false)
        if (value) {
            setSelectedScheduleType(value?.Value);
        }
    };

    const handleEmail = (event, value) => {
        setIsDisabled(false)
        const Emailaccess = value.map(x => x.trim()).filter(x => x !== "")
        setEmails(Emailaccess);
    };

    const isValid = () => {
        if (Array.isArray(emails)) {
            const validmail = emails?.map(x => UtilityService.isValidEmail(x) && x).filter(x => !x);
            return validmail.length > 0;
        } else {
            return false;
        }
    }

    const timeZone = Settings.Settings.find(x => x.Code === SettingsService.Auto_Time_Zone_Code)?.Value?.toString().toLowerCase() === "true" ? UtilityService.getDefaultTimeZone() : (Settings && Settings.Settings.length > 0 && mapToTimeZoneModel(Settings.Settings.find(x => x.Code === SettingsService.Time_Zone_Code)?.Value?.toString() || "")) || UtilityService.getDefaultTimeZone()

    const handleBlur = (e) => {
        if (!!e?.target?.value) {
            setIsDisabled(false)
            let updatedEmails = [...emails, e?.target?.value];
            let uniqueEmails = updatedEmails.filter((item, index) => updatedEmails.indexOf(item) === index);
            const trimmedEmails = uniqueEmails.map(x => x.trim()).filter(x => x !== "");
            setEmails(trimmedEmails);
            setInputvalue("")
        }
    };

    const onSubmit = (event: any) => {
        event.preventDefault();
        {
            const emailArray = Array.isArray(emails) ? emails : [];
            const obj: any = {
                "fromNumbers": PhoneNumbers.map(x => x.PhoneNumber).filter(y => !selectedToPhoneNumbers.map(y => y).includes(y)),
                "recipients": emailArray.join(';'),
                "scheduleType": ScheduleType.find(x => x.Value === Number(selectedScheduleType)).Value,
                "timeZone": timeZone.Name
            };
            ReportService.createReport(obj)
                .then(() => {
                    setIsLoading(false)
                    createReport ? setToast(ToasterTexts.REPORT_ADD_SUCCES, ToasterType.SUCCESS) : setToast(ToasterTexts.REPORT_UPDATE_SUCCES, ToasterType.SUCCESS)
                    handleRoute()
                    setIsDisabled(true)
                    setCreateReport(false)

                })
                .catch((err) => {
                    setToast(err.response.data.message, ToasterType.DANGER)
                    setIsLoading(false)
                });
        }
        setIsLoading(true)
    };

    useEffect(() => {
        ReportService.updateReport()
            .then((res) => {
                setCreateReport(!!res.data?.length ? false : true)
                setSelectedScheduleType(res.data.map(item => item.scheduleType))
                setEmails(res.data[0].recipients.split(";"))
                setInitialSelectedScheduleType(res.data.map(item => item.scheduleType));
                setInitialEmails(res.data[0].recipients.split(";"));
                setIsLoading(false)
            })
            .catch((err) => {
                setIsLoading(false)
            });
    }, [])

    const Handleinputchange = (e, value) => {
        setInputvalue(value)
    }

    return (
        <>
            <div className={` m-auto`}>
                <div className={`d-flex flex-direction w-p-100 ${IsMobileDevice ? "" : "mt-2"}`}>
                    <SettingsHeader IsMobileDevice={IsMobileDevice} Title={"Scheduled Report"} subTitle={"Set time zone automatically"} />
                </div>
                <div className={`${IsMobileDevice ? '' : 'schedule-report-border br-2 "'}`}>
                    <TextField
                        className="br-1 w-fill mx-3 mt-3"
                        placeholder='All Phone Numbers selected'
                        //  label="Select Phone Number"
                        value="All Phone Numbers"
                        size="small"
                        variant="outlined"
                        disabled
                    />
                    <Grid container className="d-flex justify-between px-3 pb-3">
                        <Typography className="mt-3 h5-medium">
                            {appNote.SELECT_FREQUENCY}
                        </Typography>
                        <Typography className="mt-3">
                            {!IsMobileDevice ? selectedScheduleType == 0 ? <div className='h5-regular color-text-field-label'>The report will be sent every Monday.</div> : <div className='h5-regular color-text-field-label'>The report will be sent on the first day of every month.</div> : ""}
                        </Typography>
                    </Grid>
                    <Autocomplete
                        className='ml-3 mr-3'
                        size="small"
                        disableClearable
                        options={ScheduleType}
                        getOptionLabel={(option: any) => option.Name}
                        onChange={handleScheduleType}
                        value={ScheduleType.find(x => x.Value === Number(selectedScheduleType))}
                        renderOption={(defaultprops, option: any) => (
                            <li {...defaultprops} className={"c-pointer h6-regular p-1 d-flex justify-between w-p-90"}>
                                {option.Name}
                            </li>
                        )}
                        classes={{ input: 'h4-regular color-text-field-font', paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                        renderInput={(params) => <TextField {...params} name="scheduleType" size="small" variant="outlined" label="Schedule Type" placeholder="Schedule Type" />}
                    />
                    {IsMobileDevice ? selectedScheduleType == 0 ? <div className="h5-regular color-text-field-label mt-1 ml-18">Report will be sent on every Monday</div> : <div className="h5-regular color-text-field-label mt-1 ml-11">Report will be sent on the first of every month</div> : ""}
                    <Grid container className="px-3 pb-3">
                        <Typography className="mt-3 h5-medium">
                            {appNote.SELECT_EMAIL}
                        </Typography>
                    </Grid>
                    <Autocomplete
                        className='ml-3 mr-3'
                        size="small"
                        multiple
                        freeSolo
                        disableClearable
                        options={[]}
                        disableCloseOnSelect={true}
                        value={emails}
                        onChange={handleEmail}
                        inputValue={inputvalue}
                        onInputChange={Handleinputchange}
                        renderInput={(params) => (<TextField {...params} size="small" label="Email Addresses" variant="outlined" placeholder="" />)}
                        onBlur={(e) => handleBlur(e)}
                        renderTags={(value, getTagProps) =>
                            value.map((option, index) => (
                                <Chip
                                    key={index}
                                    classes={{
                                        colorPrimary: UtilityService.isValidEmail(option) ? "custom-color-chip-1" : "custom-color-chip-4",
                                    }}
                                    deleteIcon={
                                        <CustomChipIcon
                                            onMouseDown={(event) => event.stopPropagation()}
                                        />
                                    }
                                    color="primary"
                                    label={option}
                                    {...getTagProps({ index })}
                                />
                            ))
                        }
                    />
                    <FormHelperText className="h5 color-primary-danger t-align-right mt-1 pr-3">
                        {isValid() && emails?.length > 10 ? (<div>Invalid email addresses and exceed the 10-address limit</div>)
                            : isValid() ? (<div>Invalid email</div>)
                                : emails?.length > 10 ? (<div>Email addresses exceed the limit of 10</div>)
                                    : null}
                    </FormHelperText>
                    <Grid container className="px-3 pb-3">
                        <Grid
                            item
                            xs={12}
                            className={`d-flex mt-2 ${IsMobileDevice ? '' : 'justify-flex-end'}`}
                        >
                            <ButtonComponent
                                Variant={isDisabled ? "disabled-btn-small" : "secondary-btn-small"}
                                ClassName={`c-pointer mr-1 ${IsMobileDevice ? 'w-100' : 'w-p-10 justify-center mb-2 br-1'}`}
                                OnClick={handleCancel}
                                ButtonLabel={buttonLabels.CANCEL}
                            />
                            <ButtonComponent
                                Variant={(isValid() || emails.length > 10) || isDisabled ? "disabled-btn-small" : "primary-btn-small"}
                                ClassName={`c-pointer w-space ${IsMobileDevice ? 'w-100' : 'w-p-10 justify-center mb-2  br-1'}`}
                                OnClick={onSubmit}
                                ButtonLabel={buttonLabels.SAVE}
                                Loading={IsLoading}
                            />
                        </Grid>
                    </Grid>
                </div>
            </div>
        </>
    )
}

export default ScheduledReport
